import React from 'react'
import { Router, RouteComponentProps } from '@reach/router'

import CenteredContentLayout from '~/layouts/CenteredContentLayout'

import UpdateXplorIdsForm from './UpdateXplorIdsForm'
import ExpiredEmail from './ExpiredEmail'
import AllDone from './AllDone'

type Props = RouteComponentProps

const UpdateXplorIds = (_props: Props) => {
  return (
    <CenteredContentLayout>
      <Router>
        <UpdateXplorIdsForm path="/confirm" />
        <ExpiredEmail path="/expired" />
        <AllDone path="/all-done" />
      </Router>
    </CenteredContentLayout>
  )
}

export default UpdateXplorIds
